<template>
    <CommonBox title="Upload File" @close="$emit('close')" @submit="$emit('close')">
       <el-upload
			class="upload-demo"
			ref="upload"
            accept=".png,.jpg"
			:action="$http.http.defaults.baseURL + 'uploadFileTechnologyPartners'"
			:headers="header"
			:data="data"
			:auto-upload="false"
			:multiple="false"
            :before-upload="beforeUpload"
			:file-list="fileList"
			:on-success="success"
            :before-remove="beforeRemove"
		>
		<el-button slot="trigger" size="small" type="primary">Select File</el-button>
                <label style="margin-left:10px;">Company：</label>
                    <el-input style="width:20%" v-model="data.Company"></el-input>

        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Upload to Server</el-button>
       <!--  <el-label style="margin-left: 30px;">Single file cannot exceed 800M</el-label> -->
		</el-upload>
        <br> 
        <span style="color:red">*Only png and jpg images are allowed to be uploaded</span>      
    </CommonBox>
</template>


<script>
import CommonBox from "@/components/common/CommonBox1.vue";

export default {
    components:{
        CommonBox
    },
    props:{
    },
    data () {
        return {
            header:{},
           
            data:{
                Company:""
            },
            fileList:[]
        };
    },
    mounted () {
        this.header = {
            "x-auth-token":localStorage.getItem('producttoken')
        };
    },
    methods:{
        submitUpload () {
            this.$refs.upload.submit();
        },
        success (response) {
            if(response.code === 0) {
                this.$baseNotice.message(response.msg);
                this.$emit("success");
                /* this.$emit("close"); */
                this.$emit("update"); 
            }else{
                this.$baseNotice.message(response.msg,"error");
            }
        },
        beforeUpload (file) {
            if(file.size > 800 * 1024 * 1024) {
                this.$message.error("The size of "+file.name+" exceeds 800M !");
                return false;
            }
        },
        //beforeRemove (file,fileList) 
        beforeRemove (file) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        }
    }
};
</script>
